<template>
    <el-form :model="form" ref="form" :rules="rules" label-position="top">
        <div class="row">
            <div class="col-md-12 ">
                <h1>{{!!data_source ? 'Edit' : 'Create'}} Data Source</h1>
                <div class="panel panel-default">
                  <div class="panel-heading">Basic Information</div>
                  <div class="panel-content pad-panel">
                    <el-row :gutter="20">
                      <el-col :span="12">
                        <el-form-item label="Full Source Name (example: Screaming Frog)" prop="source_name">
                          <el-input v-model="form.source_name">(none)</el-input>
                        </el-form-item>
                      </el-col>
                      <el-col :span="12">
                        <el-form-item label="Source Short Name (example: SF)" prop="name_short">
                          <el-input v-model="form.name_short" >(none)</el-input>
                        </el-form-item>
                      </el-col>
                    </el-row>
                    <el-row :gutter="20">
                      <el-col :span="8">
                        <div>
                          <el-form-item label="Type of Source:" prop="source_type">
                            <el-select filterable v-model="form.source_type">
                              <el-option
                                  v-for="value in source_type_options"
                                  :key = "value.key"
                                  :label = "value.label"
                                  :value = "value.key">
                              </el-option>
                            </el-select>
                          </el-form-item>
                        </div>
                      </el-col>
                      <el-col :span="8">
                        <el-form-item label="Delimiter" >
                          <el-radio-group v-model="form.delimiter_select">
                            <el-radio label="comma">comma</el-radio>
                            <el-radio label="tab">tab</el-radio>
                          </el-radio-group>
                        </el-form-item>
                      </el-col>
                      <el-col :span="8">
                        <el-form-item label="Skip Rows">
                          <el-input-number v-model="form.skip_rows" :min="0"></el-input-number>
                        </el-form-item>
                      </el-col>
                    </el-row>
                    <p>In many cases, some rows need to be skipped. In rare cases, it's tab-delimited rather than comma-delimited.</p>
                  </div>
                </div>

              <div class="panel panel-default">

              <el-collapse v-model="activeCollapsePanels" @change="handleCollapseChange">
                  <el-collapse-item name="get_headers">
                    <template slot="title">
                      <span class="panel-heading">Get Headers</span>
                    </template>

                    <div class="panel-content pad-panel">
                      <el-form-item>
                        <el-upload
                            drag
                            :on-success="afterSuccessfulUpload"
                            action="/api/uploads">
                          <i class="el-icon-upload"></i>
                          <div class="el-upload__text">Drop file here or <em>click to upload</em></div>
                          <div class="el-upload__tip" slot="tip">Upload CSVs up to 2GB.</div>
                        </el-upload>
                      </el-form-item>

                      <p>{{header_text}}</p>

                      <p>In most cases, you can just upload your file and headers will be discovered automatically.</p>
                    </div>
                  </el-collapse-item>

              </el-collapse>

              </div>

                <div class="panel panel-default">
                    <div class="panel-heading">Define Base Fields</div>
                      <div class="panel-content pad-panel">
                        <el-row :gutter="20">
                          <el-col :span="8">
                            <el-form-item label="Address" prop="selected_address_field">
                              <el-select filterable v-model="form.selected_address_field" clearable value-key="label">
                                <el-option
                                    v-for="item in headers"
                                    :label="item.label"
                                    :value="item"
                                    :disabled="isOptionSelectedAlready(item)">
                                </el-option>
                              </el-select>
                            </el-form-item>
                          </el-col>
                          <el-col :span="16">
                            <el-form-item label="Address Prefix" prop="address_prefix">
                              <el-input v-model="form.address_prefix">(none)</el-input>
                            </el-form-item>
                          </el-col>
                        </el-row>

                        <el-row :gutter="20">
                          <el-col :span="8">
                            <el-form-item label="Title" prop="selected_title_field">
                              <el-select filterable v-model="form.selected_title_field" value-key="label" clearable placeholder="(none)">
                                <el-option
                                    v-for="item in headers"
                                    :label = "item.label"
                                    :value = "item"
                                    :disabled="isOptionSelectedAlready(item)">
                                </el-option>
                              </el-select>
                            </el-form-item>
                          </el-col>
                          <el-col :span="8">
                            <el-form-item label="Status" prop="selected_status_field">
                              <el-select filterable v-model="form.selected_status_field" value-key="label" clearable placeholder="(none)">
                                <el-option
                                    v-for="item in headers"
                                    :label = "item.label"
                                    :value = "item"
                                    :disabled="isOptionSelectedAlready(item)">
                                </el-option>
                              </el-select>
                            </el-form-item>

                          </el-col>
                          <el-col :span="8">
                            <el-form-item label="Mime Type" prop="selected_mime_type_field">
                              <el-select filterable v-model="form.selected_mime_type_field" value-key="label" clearable placeholder="(none)">
                                <el-option
                                    v-for="item in headers"
                                    :label = "item.label"
                                    :value = "item"
                                    :disabled="isOptionSelectedAlready(item)">
                                </el-option>
                              </el-select>
                            </el-form-item>

                          </el-col>
                        </el-row>

                        <p>*There must be a corresponding Address field in the source data. In some cases, the imported data has
                        abbreviated addresses (for example, /webinars instead of https://davidhobbsconsulting.com/webinars) in which
                        case the prefix (for example, https://davidhobbsconsulting.com) must also be defined so that merges and deduplication
                            can be done effectively.</p>
                  </div>
                </div>
                <div class="panel panel-default">
                    <div class="panel-heading">
                      Define Custom Fields
                      <el-tooltip placement="right">
                        <i class="el-icon-info"></i>
                        <div slot="content">
                          This is only filled in if you upload an example CSV from this page.
                        </div>
                      </el-tooltip>
                    </div>
                    <div class="panel-content pad-panel">

                      <el-table
                          :data="selectable_custom_fields"
                          style="width: 100%">
                        <el-table-column
                            prop="label"
                            label="Field in CSV">
                        </el-table-column>
                        <el-table-column
                            prop="import"
                            label="Import?">
                          <template slot-scope="scope">
                            <el-checkbox v-model="scope.row.import" />
                          </template>
                        </el-table-column>
                        <el-table-column
                            prop="aggregation"
                            label="How to deal with duplicates?">
                          <template slot-scope="scope">
                            <el-select v-model="scope.row.aggregation" placeholder="Select">
                              <el-option
                                  v-for="item in aggregation_options"
                                  :key="item.value"
                                  :label="item.label"
                                  :value="item.value">
                              </el-option>
                            </el-select>

                          </template>
                        </el-table-column>
                        <el-table-column
                            prop="example"
                            label="Example Value"
                        >
                        </el-table-column>
                      </el-table>



                    </div>
                </div>
                <div>
                    <el-button type="primary" style="margin:20px 0 30px 0" v-on:click="submit">Submit</el-button>
                    <el-button style="margin:20px 0 30px 0" v-on:click="returnToAssets">Cancel</el-button>
                </div>

            </div>
        </div>
    </el-form>
</template>
<script>

    export default {
        props: [
            'extent_id',
            'data_source'
        ],
        methods: {
            isOptionSelectedAlready(option) {
                return !this.selectable_custom_fields.some(field => field.label === option.label);
            },
            fillDataSource() {
                this.form.delimiter_select = this.data_source.special_delimiter === ',' ? 'comma' : 'tab';
                this.form.skip_rows = this.data_source.skip_rows;
                this.form.source_type = this.data_source.source_type;
                this.form.source_name = this.data_source.source_name;
                this.form.name_short = this.data_source.name_short;
                this.form.address_prefix = this.data_source.address_prefix;

                let count = 0;

                let base_fields = [
                    this.data_source.address_fieldname,
                    this.data_source.title_fieldname,
                    this.data_source.status_fieldname,
                    this.data_source.mime_type_fieldname
                ].filter(Boolean);

                let mapped_base_fields = base_fields.map(field => {
                    count++;
                    return {
                      'aggregation': 'avg',
                      'example': 'N/A',
                      'import': true,
                      'key': count,
                      'label': field,
                      'order': count,
                    };
                });

              this.form.selected_address_field = mapped_base_fields.find(field => field.label === this.data_source.address_fieldname);
              this.form.selected_title_field = mapped_base_fields.find(field => field.label === this.data_source.title_fieldname);
              this.form.selected_status_field = mapped_base_fields.find(field => field.label === this.data_source.status_fieldname);
              this.form.selected_mime_type_field = mapped_base_fields.find(field => field.label === this.data_source.mime_type_fieldname);

              let mapped_custom_fields = this.data_source.data_source_custom_fields.map(field => {
                    count++;
                    return {
                        'aggregation': field.aggregation_for_duplicates,
                        'example': 'N/A',
                        'import': true,
                        'key': count,
                        'label': field.field_name,
                        'order': count,
                      }
                  });

                this.headers = [...mapped_base_fields, ...mapped_custom_fields];
            },
            getHeaders() {
                axios.post('/api/dataSource/headers', {
                    delimiter: this.delimiter,
                    skip_rows: this.form.skip_rows,
                    upload_file: this.form.upload_file
                }).then(response => {
                    this.headers = response.data
                }).catch(error => {
                    console.log('oops getting header')
                    console.log(error.response)
                })
                //
            },
            afterSuccessfulUpload(response, file, fileList) {
                this.form.upload_file = response
                this.getHeaders();
            },
            submit() {
              this.$refs.form.validate((valid) => {
                if (valid) {
                  if (this.data_source) {
                    this.editDataSource();
                  } else {
                    this.createDataSource();
                  }
                } else {
                  console.log('error');
                  return false;
                }
              })
            },
            buildPayload() {
              let data = {
                values: {
                  source_type: this.form.source_type,
                  source_name: this.form.source_name,
                  name_short:	this.form.name_short,
                  address_fieldname: this.form.selected_address_field.label,
                  title_fieldname: this.form.selected_title_field?.label,
                  status_fieldname: this.form.selected_status_field?.label,
                  mime_type_fieldname: this.form.selected_mime_type_field?.label,
                  skip_rows: this.form.skip_rows,
                  special_delimiter: this.delimiter,
                  sitename_fieldname:	null,
                  address_prefix: this.form.address_prefix,
                },
                custom_columns: this.custom_fields_to_submit
              };

              return data;
            },
            createDataSource() {
                let data = this.buildPayload();
                axios.post('/api/dataSources/' + this.extent_id, data)
                    .then(response => {
                      this.returnToAssets();
                  console.log('finished saving new data source')
                }).catch(error => {
                  console.log('Could not save new data source')
                  console.log(error.response)
                });
            },
            editDataSource() {
                let data = this.buildPayload();

                axios.put('/api/dataSources/' + this.extent_id + '/' + this.data_source.id, data)
                    .then(response => {
                      this.returnToAssets();
                      console.log('Updated data source');
                    })
                    .catch(error => {
                      console.log(error.response);
                      console.log('problem editing data source');
                    })
            },
            returnToAssets() {
              window.location.href = '/assets';
            },
            handleCollapseChange(val) {
              this.activeCollapsePanels = val;
            }
        },
        computed: {
            delimiter: function() {
                if (this.form.delimiter_select === 'tab') {
                    return '\t'
                } else {
                    return ','
                }
            },
            header_count: function() {
                if (this.headers) {
                    return this.headers.length
                } else {
                    return 0
                }
            },
            header_text: function() {
                if (this.header_count) {
                    return "Found " + this.header_count + " headers."
                } else {
                    return "No headers yet found."
                }

            },
            selectable_custom_fields: function() {
                let exclude_headers = [
                    this.form.selected_mime_type_field?.label,
                    this.form.selected_status_field?.label,
                    this.form.selected_title_field?.label,
                    this.form.selected_address_field?.label
                ];

                return this.headers.filter(header => !exclude_headers.includes(header.label));
            },
            custom_fields_to_submit: function() {
                return this.selectable_custom_fields.filter(header => header.import);
            }
        },
        data() {
            return {
              headers: [],
              activeCollapsePanels: ['get_headers'],
              form: {
                    delimiter_select: 'comma',
                    skip_rows: 0,
                    upload_file: null,
                    selected_address_field: null,
                    address_prefix: null,
                    selected_title_field: null,
                    selected_status_field: null,
                    selected_mime_type_field: null,
                    name_short: null,
                    source_type: null,
                    source_name: null,
                  },
                aggregation_options: [
                  {
                    value: 'sum',
                    label: 'Sum'
                  },
                  {
                    value: 'avg',
                    label: 'Average'
                  },
                  {
                    value: 'any',
                    label: 'Any'
                  }
                ],

                source_type_options: [
                    {
                      'key': 'spider',
                      'label': 'Spider',
                    },
                    {
                      'key': 'analytics',
                      'label': 'Analytics',
                    },
                    {
                      'key': 'cms',
                      'label': 'CMS',
                    },
                    {
                      'key': 'other',
                      'label': 'Other',
                    },
                ],
                rules: {
                  selected_address_field: [
                    { required: true, message: 'Please select column for Address field.', trigger: 'change' }
                  ],
                  name_short: [
                    { required: true, message: 'Please enter short name for data source.', trigger: 'change' }
                  ],
                  source_name: [
                    { required: true, message: 'Please enter full name for data source.', trigger: 'change' }
                  ],
                  source_type: [
                    { required: true, message: 'Please select source type.', trigger: 'change' }
                  ]
                }
            }
        },
        created() {
          if (this.data_source) {
            this.fillDataSource();
            this.activeCollapsePanels = [];
          }
        }
    }
</script>

<style>
  .pad-panel {
    padding: 10px 25px 10px 25px;
  }

  /* Override display to place chevron toggle icon immediately to right of "Get Headers" label*/
  .el-collapse-item__header {
    display: block;
  }
</style>
